<template>
    <div class="sidebar-wrapper">
        <aside :class="['left-sidebar',]">
            <nav class="sidebar-nav">
                <router-link to="/" class="brand-container" style="text-decoration: none;">
                    <img src="@/assets/icons/iconApp.svg" alt="App" class="app-svg" />
                    <h3 class="app-name">{{ AppEssentials.AppName }}</h3>
                </router-link>
                <ul class="sidebar-list">
                    <li>
                        <router-link to="/" exact-active-class="active">
                            <div class="icon-wrapper">
                                <img src="@/assets/icons/iconHome.svg" alt="Home" class="sidebar-icon" />
                            </div>
                            <span class="nav-label">Home</span>
                        </router-link>
                    </li>
                    <li :class="{ active: isVgActive }">
                        <a @click="onVoiceGallery" active-class="active">
                            <div class="icon-wrapper">
                                <img src="@/assets/icons/iconMic.svg" alt="Voice Gallery" class="sidebar-icon" />
                            </div>
                            <span class="nav-label">Voice Gallery</span>
                        </a>
                    </li>
                    <li :class="{ active: isVdActive }">
                        <a @click="onVoiceDesigner" active-class="active">
                            <div class="icon-wrapper">
                                <img src="@/assets/icons/iconDesign.svg" alt="Voice Designer" class="sidebar-icon" />
                            </div>
                            <span class="nav-label">Voice Designer</span>
                        </a>
                    </li>
                    <li :class="{ active: isTTSActive }">
                        <a @click="onTTS" active-class="active">
                            <div class="icon-wrapper">
                                <img src="@/assets/icons/iconTts.svg" alt="Text To Speech" class="sidebar-icon" />
                            </div>
                            <span class="nav-label">Text To Speech</span>
                        </a>
                    </li>
                </ul>
                <div class="sidebar-bottom">
                    <ul>
                        <li class="pricing">
                            <router-link to="/pricing" active-class="active">Pricing</router-link>
                        </li>
                        <template v-if="!isAuthenticated">
                            <li class="about">
                                <router-link to="/about" active-class="active">About</router-link>
                            </li>
                            <li class="login">
                                <a href="#" @click.prevent="handleLogin">Login</a>
                            </li>
                            <li class="register">
                                <a href="#" @click.prevent="handleRegister">Register</a>
                            </li>
                        </template>
                        <template v-else>
                            <li class="user">
                                <router-link to="/credit" active-class="active">Credit</router-link>
                            </li>
                            <li class="user">
                                <router-link to="/referral" active-class="active">Referral</router-link>
                            </li>
                            <li class="about">
                                <router-link to="/about" active-class="active">About</router-link>
                            </li>
                            <li class="user">
                                <div class="profile-area" @click.stop="toggleProfileDropdown" ref="profileMenuRef"
                                    tabindex="0">
                                    <div class="profile-pic">{{ getDisplayUsername().charAt(0) }}</div>
                                    <div class="profile-username" :title="getFullDisplayUsername()">{{
                                        getDisplayUsername()
                                    }}</div>
                                    <ul v-if="showProfileDropdown" class="profile-dropdown" @click.stop>
                                        <li class="profile-dropdown-username" :title="getFullDisplayUsername()">
                                            {{ getFullDisplayUsername() }}
                                        </li>
                                        <li @click="goProfile">Profile</li>
                                        <li @click="handleLogout">Logout</li>
                                    </ul>
                                </div>
                            </li>
                        </template>
                    </ul>
                </div>
            </nav>
        </aside>
    </div>
</template>

<script>
import AppEssentials from '@/data/AppEssentials.js'
import { inject, ref, onMounted, onUnmounted, computed } from 'vue'
import { logout } from '@/api/auth'
import { useRouter, useRoute } from 'vue-router'
export default {
    name: "LeftSidebar",
    setup() {
        const route = useRoute()
        const isTTSActive = computed(() => route.path.startsWith('/text-to-speech'))
        const isVdActive = computed(() => route.path.startsWith('/voice-design'))
        const isVgActive = computed(() => route.path.startsWith('/voice-gallery'))

        const keycloak = inject('keycloak')
        const dropdown = ref(false)
        const menuRef = ref(null)
        const username = ref('');

        const showProfileDropdown = ref(false);
        const profileMenuRef = ref(null);
        const router = useRouter();

        function toggleProfileDropdown() {
            showProfileDropdown.value = !showProfileDropdown.value;
        }
        function closeProfileDropdown(e) {
            if (
                profileMenuRef.value &&
                !profileMenuRef.value.contains(e.target)
            ) {
                showProfileDropdown.value = false;
            }
        }
        function goProfile() {
            showProfileDropdown.value = false;
            router.push('/profile');
        }
        function getFullDisplayUsername() {
            let name = username.value || 'User';
            if (name.includes('@')) {
                name = name.split('@')[0];
            }
            return name.trim() || 'User';
        }
        function getDisplayUsername() {
            return getFullDisplayUsername();
        }

        const authToken = ref('')

        const isAuthenticated = computed(() => {
            return authToken.value && authToken.value !== ''
        })
        onMounted(() => {
            checkAuthStatus()
            window.addEventListener('storage', checkAuthStatus)
            document.addEventListener('click', onClickOutside);
            document.addEventListener('click', closeProfileDropdown);

        })
        onUnmounted(() => {
            document.removeEventListener('click', onClickOutside);
            document.removeEventListener('click', closeProfileDropdown);

        })

        function checkAuthStatus() {
            authToken.value = localStorage.getItem('auth_token') || ''
            username.value = localStorage.getItem('username') || 'User'
        }

        function toggleDropdown() {
            dropdown.value = !dropdown.value
        }

        function onClickOutside(e) {
            if (menuRef.value && !menuRef.value.contains(e.target)) {
                dropdown.value = false
            }
        }
        function handleLogin() {
            keycloak.login()
        }
        function handleRegister() {
            keycloak.register()
        }
        function handleLogout() {
            logout()
        }
        function onVoiceGallery() {
            if (!isAuthenticated.value) {
                router.push({ path: '/demo', query: { demoTarget: 'voiceGallery' } });
                return;
            }
            router.push({ path: '/voice-gallery' });
        }
        function onVoiceDesigner() {
            if (!isAuthenticated.value) {
                router.push({ path: '/demo', query: { demoTarget: 'voiceDesigner' } });
                return;
            }
            router.push({ path: '/voice-designer' });
        }
        function onTTS() {
            if (!isAuthenticated.value) {
                router.push({ path: '/demo', query: { demoTarget: 'TTS' } });
                return;
            }
            router.push({ path: '/text-to-speech-projects' });
        }
        return {
            isTTSActive,
            isVdActive,
            isVgActive,
            AppEssentials,
            getDisplayUsername,
            getFullDisplayUsername,
            dropdown,
            menuRef,
            isAuthenticated,
            toggleDropdown,
            handleLogin,
            handleRegister,
            handleLogout,
            showProfileDropdown,
            profileMenuRef,
            toggleProfileDropdown,
            goProfile,
            onVoiceGallery,
            onVoiceDesigner,
            onTTS,
        };
    }
};
</script>

<style scoped>
.sidebar-wrapper {
    height: 100%;
    min-height: 0;
    background-color: var(--background-white);
}

.left-sidebar {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    position: relative;
    z-index: 1000;
    height: 100%;
    min-height: 0;

    box-shadow: 6px 0 16px -4px rgba(80, 60, 180, 0.10);

}

.sidebar-nav {
    display: flex;
    flex-direction: column;
    height: 100vh;
    padding: 0.75rem 0.5rem;
}

.brand-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
}

.app-svg {
    width: 28px;
    height: 28px;
    display: block;
    transition: filter 0.3s, color 0.3s;
    filter: var(--purple-filter)
}

.app-name {
    font-weight: 700;
    font-size: 16px;
    color: black;
    margin: 0 0 0.35rem 0;
    text-align: center;
    display: block;
    flex-shrink: 0;
}

.sidebar-list {
    list-style: none;
    padding: 0;
    margin: 0;
    flex: 0 1 auto;
}

.sidebar-bottom {
    margin-top: auto;
}

.sidebar-bottom ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0;
}

.sidebar-nav ul>li {
    flex-shrink: 0;
}

.sidebar-nav ul::after {
    content: "";
    flex: 1 1 auto;
}

.sidebar-nav ul>li.pricing,
.sidebar-nav ul>li.about,
.sidebar-nav ul>li.login,
.sidebar-nav ul>li.register,
.sidebar-nav ul>li.user {
    margin-top: auto;
}

.sidebar-nav ul li.active>a {
    background-color: #F4F3FF;
    color: var(--purple);
}

.sidebar-nav ul {
    list-style: none;
    padding: 0;
}

.sidebar-nav li a {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.65rem 0.35rem;
    text-decoration: none;
    color: var(--text-secondary);
    border-radius: 6px;
    margin-top: 4px;
    transition: background-color 0.3s ease, color 0.3s ease;
    text-align: center;
    font-size: 13px;
    cursor: pointer;
}

.nav-label {
    display: block;
    line-height: 1.15;
    max-width: 72px;
    overflow-wrap: normal;
    text-align: center;
    white-space: normal;
    word-break: normal;
}

.sidebar-nav li a:hover,
.sidebar-nav li a.active {
    background-color: #F4F3FF;
    color: var(--purple);
}

.icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0.25rem;
}

.sidebar-icon {
    width: 24px;
    height: 24px;
    transition: filter 0.3s, color 0.3s;
    filter: grayscale(1) brightness(0.7);
}

.sidebar-nav li a:hover .sidebar-icon,
.sidebar-nav li a.active .sidebar-icon {
    filter: var(--purple-filter)
}

.sidebar-nav li.active .sidebar-icon {
    filter: var(--purple-filter);
}

.user-menu {
    position: relative;
}

.user-btn {
    background: none;
    border: none;
    font-weight: 500;
    color: #222;
    cursor: pointer;
    display: flex;
    align-items: center;
    font: inherit;
    gap: 8px;
    text-decoration: none;
}


.dropdown {
    position: absolute;
    right: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 6px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
    min-width: 120px;
    z-index: 1000;
}

.dropdown li {
    margin: 0;
    padding: 0.75rem 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.dropdown li:hover {
    background-color: #f5f5fa;
}

.profile-area {
    margin-top: 1rem;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    cursor: pointer;
    outline: none;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
}

.profile-pic {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: var(--purple);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 1rem;
    font-weight: 700;
    text-transform: uppercase;
    user-select: none;
    position: relative;
    z-index: 1;
    margin: 4px;
    box-sizing: border-box;
}

.profile-pic::before {
    content: "";
    position: absolute;
    top: -6px;
    left: -6px;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: 2.5px solid var(--purple);
    background: transparent;
    z-index: 0;
    box-sizing: border-box;
}

.profile-username {
    font-size: 14px;
    line-height: 1.2;
    text-align: center;
    max-width: 100%;
    padding: 0 0.25rem;
    box-sizing: border-box;
    color: var(--text-secondary);
    overflow: hidden;
    overflow-wrap: anywhere;
    word-break: break-word;
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.profile-dropdown {
    position: absolute;
    bottom: 110%;
    left: auto;
    right: 0;
    transform: none;
    min-width: 120px;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    z-index: 1001;
    padding: 0.5rem 0;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    max-width: 90vw;
}

.profile-dropdown li {
    padding: 0.75rem 1.25rem;
    cursor: pointer;
    color: #222;
    font-size: 14px;
    text-align: center;
    /* Center text horizontally */
    white-space: nowrap;
    transition: background 0.15s;
    justify-content: center;
    /* Center flex content horizontally */
    display: flex;
    /* Ensure flex context */
    align-items: center;
}

.profile-dropdown li:hover {
    background: #f4f3ff;
    color: var(--purple);
}

.profile-dropdown .profile-dropdown-username {
    cursor: default;
    color: var(--text-secondary);
    font-size: 12px;
    font-weight: 600;
    line-height: 1.25;
    padding: 0.65rem 1rem;
    border-bottom: 1px solid var(--border-color);
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
}

.profile-dropdown .profile-dropdown-username:hover {
    background: transparent;
    color: var(--text-secondary);
}

.profile-dropdown {
    right: auto;
    left: 50%;
    transform: translateX(-50%);
    max-width: 90vw;
    min-width: 120px;
}
</style>
